module.exports = __webpack_public_path__ + "static/media/buscador-series.b4514f36.png";